import React from 'react';
import {
    AddressLocation,
    AddressLocationControlPadding,
    AddressLocationFontSize,
    AddressLocationIndicatorStyle,
    AddressLocationLine1Style,
    Card,
    CardBorderRadius,
    CardBorderStyle,
    CardHeaderTheme,
    CardTheme,
} from '@apply/components';

export const CardDemo: React.FC = () => {
    const headerContent = () => {
        return 'This is the header of the card';
    };

    const headerContentAddress = () => {
        return (
            <AddressLocation
                addressLine1='1138 Mockingbird Lane, Grandview TX 76012'
                indicatorStyle={AddressLocationIndicatorStyle.Gray}
                line1Style={AddressLocationLine1Style.Bold}
                controlPadding={AddressLocationControlPadding.None}
                fontSize={AddressLocationFontSize.Smaller}
            />
        );
    };

    const subCardHeaderContent = () => {
        return (
            <AddressLocation
                addressLine1='1138 Mockingbird Lane, Grandview TX 76012'
                indicatorStyle={AddressLocationIndicatorStyle.Gray}
                line1Style={AddressLocationLine1Style.Bold}
                controlPadding={AddressLocationControlPadding.None}
                fontSize={AddressLocationFontSize.Smaller}
            />
        );
    };

    const subCardHeaderContentNoIndicator = () => {
        return (
            <AddressLocation
                addressLine1='1138 Mockingbird Lane, Grandview TX 76012'
                indicatorStyle={AddressLocationIndicatorStyle.Gray}
                line1Style={AddressLocationLine1Style.Bold}
                controlPadding={AddressLocationControlPadding.None}
                showIndicator={false}
                fontSize={AddressLocationFontSize.Smaller}
            />
        );
    };

    return (
        <div style={{ marginTop: '0px', marginBottom: '20px' }}>
            <h2>Cards :</h2>
            <br />
            <b>Color Cards</b>
            <br />
            <br />
            <Card
                header={headerContent()}
                headerTheme={CardHeaderTheme.Blue}
                theme={CardTheme.Blue}
                borderRadius={CardBorderRadius.Small}
                borderStyle={CardBorderStyle.Solid}
            >
                Blue Panel
            </Card>
            <Card
                header={headerContent()}
                headerTheme={CardHeaderTheme.White}
                theme={CardTheme.White}
                borderRadius={CardBorderRadius.Small}
                borderStyle={CardBorderStyle.Solid}
                showHeaderSeperator={true}
            >
                White Panel
            </Card>
            <Card
                header={headerContent()}
                headerTheme={CardHeaderTheme.Red}
                theme={CardTheme.Red}
                borderRadius={CardBorderRadius.Small}
                borderStyle={CardBorderStyle.Solid}
            >
                Red Panel
            </Card>
            <Card
                header={headerContent()}
                headerTheme={CardHeaderTheme.Gray}
                theme={CardTheme.Gray}
                borderRadius={CardBorderRadius.Small}
                borderStyle={CardBorderStyle.Solid}
                showHeaderSeperator={true}
            >
                Gray Panel
            </Card>
            <Card
                header={headerContent()}
                headerTheme={CardHeaderTheme.Yellow}
                theme={CardTheme.Yellow}
                borderRadius={CardBorderRadius.Small}
                borderStyle={CardBorderStyle.Solid}
            >
                Yellow Panel
            </Card>
            <br />
            <b>Color Cards (Header Only)</b>
            <br />
            <br />
            <Card
                header={headerContent()}
                headerTheme={CardHeaderTheme.Blue}
                theme={CardTheme.White}
                borderRadius={CardBorderRadius.Small}
                borderStyle={CardBorderStyle.Solid}
            >
                Blue Panel
            </Card>
            <Card
                header={headerContent()}
                headerTheme={CardHeaderTheme.White}
                theme={CardTheme.White}
                borderRadius={CardBorderRadius.Small}
                borderStyle={CardBorderStyle.Solid}
                showHeaderSeperator={true}
            >
                White Panel
            </Card>
            <Card
                header={headerContent()}
                headerTheme={CardHeaderTheme.Red}
                theme={CardTheme.White}
                borderRadius={CardBorderRadius.Small}
                borderStyle={CardBorderStyle.Solid}
            >
                Red Panel
            </Card>
            <Card
                header={headerContent()}
                headerTheme={CardHeaderTheme.Gray}
                theme={CardTheme.White}
                borderRadius={CardBorderRadius.Small}
                borderStyle={CardBorderStyle.Solid}
                showHeaderSeperator={true}
            >
                Gray Panel
            </Card>
            <Card
                header={headerContent()}
                headerTheme={CardHeaderTheme.Yellow}
                theme={CardTheme.White}
                borderRadius={CardBorderRadius.Small}
                borderStyle={CardBorderStyle.Solid}
            >
                Yellow Panel
            </Card>
            <br />
            <b>Color Cards (Header Only - Address Location Example)</b>
            <br />
            <br />
            <Card
                header={headerContentAddress()}
                headerTheme={CardHeaderTheme.Blue}
                theme={CardTheme.White}
                borderRadius={CardBorderRadius.Small}
                borderStyle={CardBorderStyle.Solid}
            >
                Blue Panel
            </Card>
            <Card
                header={headerContentAddress()}
                headerTheme={CardHeaderTheme.White}
                theme={CardTheme.White}
                borderRadius={CardBorderRadius.Small}
                borderStyle={CardBorderStyle.Solid}
                showHeaderSeperator={true}
            >
                White Panel
            </Card>
            <Card
                header={headerContentAddress()}
                headerTheme={CardHeaderTheme.Red}
                theme={CardTheme.White}
                borderRadius={CardBorderRadius.Small}
                borderStyle={CardBorderStyle.Solid}
            >
                Red Panel
            </Card>
            <Card
                header={headerContentAddress()}
                headerTheme={CardHeaderTheme.Gray}
                theme={CardTheme.White}
                borderRadius={CardBorderRadius.Small}
                borderStyle={CardBorderStyle.Solid}
                showHeaderSeperator={true}
            >
                Gray Panel
            </Card>
            <Card
                header={headerContentAddress()}
                headerTheme={CardHeaderTheme.Yellow}
                theme={CardTheme.White}
                borderRadius={CardBorderRadius.Small}
                borderStyle={CardBorderStyle.Solid}
            >
                Yellow Panel
            </Card>
            <br />
            <b>Card - With Transparent Children Cards</b>
            <br />
            <br />
            <Card
                header={headerContent()}
                headerTheme={CardHeaderTheme.Blue}
                theme={CardTheme.White}
                borderRadius={CardBorderRadius.Small}
                borderStyle={CardBorderStyle.Solid}
            >
                Panel With Sub Panels
                <br />
                <br />
                <Card
                    header={subCardHeaderContent()}
                    headerTheme={CardHeaderTheme.Gray}
                    theme={CardTheme.Transparent}
                    borderRadius={CardBorderRadius.Small}
                    borderStyle={CardBorderStyle.Solid}
                >
                    Item 1
                </Card>
                <Card
                    header={subCardHeaderContent()}
                    headerTheme={CardHeaderTheme.Gray}
                    theme={CardTheme.Transparent}
                    borderRadius={CardBorderRadius.Small}
                    borderStyle={CardBorderStyle.Solid}
                >
                    Item 2
                </Card>
                <Card
                    header={subCardHeaderContent()}
                    headerTheme={CardHeaderTheme.Gray}
                    theme={CardTheme.Transparent}
                    borderRadius={CardBorderRadius.Small}
                    borderStyle={CardBorderStyle.Solid}
                >
                    Item 3
                </Card>
                <Card
                    header={subCardHeaderContentNoIndicator()}
                    headerTheme={CardHeaderTheme.Gray}
                    theme={CardTheme.Transparent}
                    borderRadius={CardBorderRadius.Small}
                    borderStyle={CardBorderStyle.Solid}
                >
                    Item 4
                </Card>
            </Card>
        </div>
    );
};
